import React from "react";
import styled from "styled-components";
import { Link as LinkS } from "react-router-dom";
import { LogoImg } from "./HeroNavbar";

const Nav = styled.nav`
  width: 100%;
  padding: 1rem 2rem;
  border-bottom: 2px solid var(--l-gray);
  background: var(--white);
`;

const NavLink = styled(LinkS)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-decoration: none;
  font-size: 28px;
  font-weight: 600;
  color: var(--black);

  @media screen and (max-width: 500px) {
    justify-content: center;
  }
`;

const Navbar = () => {
  return (
    <Nav>
      <NavLink to="/">
        <LogoImg src="../PublicImages/TE-Expanded-Logo-Dark.png" alt="logo" />
      </NavLink>
    </Nav>
  );
};

export default Navbar;
